module.exports = __webpack_public_path__ + "img/Ambetsman.a6106f15.png";